import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'la-toolbar-button',
  templateUrl: './toolbar-button.component.html',
  styleUrl: './toolbar-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, MatButtonModule, MatTooltipModule, MatIconModule],
})
export class ToolbarButtonComponent {
  @Input() icon?: string;
  @Input() selected = false;
  @Input() disabled = false;

  @Input({ transform: booleanAttribute }) single = false;
  @Input() tooltipForEnabled?: string;
  @Input() tooltipForDisabled?: string;

  @Output() action = new EventEmitter<PointerEvent>();

  get hasTooltip(): boolean {
    return !!this.tooltipForDisabled || !!this.tooltipForEnabled;
  }

  get tooltip(): string | undefined {
    return this.disabled ? this.tooltipForDisabled : this.tooltipForEnabled;
  }
}
